import { FETCH_CATALOGACAO_RELATORY } from './CatalogacaoRelatoryActions'

const INITIAL_STATE = {
  data: [],
  meta: {},
  loading: false,
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CATALOGACAO_RELATORY.ACTION:
      return { ...state, loading: true }

    case FETCH_CATALOGACAO_RELATORY.SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        meta: action.payload.data.meta,
        loading: false,
      }

    case FETCH_CATALOGACAO_RELATORY.FAILURE:
      return { ...state, loading: false }

    default:
      return state
  }
}
